import React from 'react';

import { isEmpty } from 'lodash';
import { faCircleExclamation } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { DialogClose, DialogFooter } from '@/components/ui/dialog';
import { Form as ShadcnForm } from '@/components/ui/form';
import { Alert } from '../../../../../../shared/components/Alert';
import { SelectField, SubmitButton } from '../../../../../../shared/components/Form';
import { ERROR_TITLES } from '../../constants';
import { useReviewRequestForm } from '../../hooks';

const Form = () => {
  const {
    cases,
    channels,
    errorMessage,
    form,
    handleSubmit: onSubmit,
    isLoading,
  } = useReviewRequestForm();

  // :caseOptions and :channelOptions are small arrays consisting of simple objects.
  // Therefore, useMemo is not applied.
  const caseOptions = cases.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

  const channelOptions = channels.map(({ value }) => ({
    label: value,
    value: value,
  }));

  return (
    <ShadcnForm {...form}>
      <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)}>
        <SelectField
          control={form.control}
          label="Case"
          name="taskId"
          options={caseOptions}
          placeholder="Select a case"
        />

        <SelectField
          control={form.control}
          label="Channel"
          name="channel"
          options={channelOptions}
          placeholder="Select a channel"
        />

        {!isEmpty(errorMessage) && (
          <Alert
            description={errorMessage}
            icon={<FontAwesomeIcon icon={faCircleExclamation} />}
            title={ERROR_TITLES.reviewRequest.create}
            variant="destructive"
          />
        )}

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>

          <SubmitButton isLoading={isLoading}>Save</SubmitButton>
        </DialogFooter>
      </form>
    </ShadcnForm>
  );
};

export default Form;
